/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Steps as DesignSteps } from '@whalecloud/fdx';
import { useHandler } from "@whalecloud/page-builder-core/hooks/useHandler";
import isEqual from "lodash/isEqual";
import Element from '@whalecloud/page-builder-core/components/Element';
import { set } from 'dot-prop-immutable';
import { getElementWithChildren } from '@whalecloud/page-builder-core/selectors';
import ConnectedSlate from "@whalecloud/page-builder-core/components/Slate";
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const { Step } = DesignSteps;

const StepsElement = (props) => {
  const {
    elementStyle,
    elementAttributes,
    customClasses,
    combineClassNames,
    element,
  } = props;

  const { elements, data: { formItemSettings = {}, formSettings = {}, settings = {}, className = '' } } = element;
  const { visible } = settings;
  const { steps = [], defaultActiveKey, ...restProps } = formItemSettings;
  const [activeKey, setActiveKey] = useState(typeof defaultActiveKey === 'number' ? defaultActiveKey : 0);

  const handleChange = activeKey => {
    setActiveKey(activeKey);
  }

  useEffect(() => {
    if (defaultActiveKey) {
      setActiveKey(defaultActiveKey);
    }
  }, [defaultActiveKey]);

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <div
        className={combineClassNames('webiny-pb-layout-tabs webiny-pb-base-page-element-style', ...customClasses)}
        {...elementAttributes}
      >
        <DesignSteps current={activeKey} onChange={handleChange} {...restProps}>
          {steps.map((child, i) => (
              <Step status={child.status} title={child.title} description={child.description} />
            ))
          }
        </DesignSteps>
      </div>
    </FormItem>
  );
};

export default connect<any, any, any>(
  (state, props) => {
    const element = getElementWithChildren(state, props.elementId);
    return { element: { ...element } }
  },
  null,
  null,
  {
    areStatePropsEqual: isEqual,
  })(React.memo(StepsElement));
